import { Switch as MantineSwitch, SwitchProps } from '@mantine/core';
import { FC, memo } from 'react';
import { useFormContext } from 'src/form';

import styles from './styles.module.css';

type Props = Omit<SwitchProps, 'name'> & {
  name: string;
};

export const Switch: FC<Props> = memo(({ name, ...props }) => {
  const form = useFormContext();
  const formProps = form.getInputProps(name);

  const { value, onChange, ...restFormProps } = formProps;

  return (
    <MantineSwitch
      {...props}
      {...restFormProps}
      classNames={{
        track: styles.input,
        label: styles.input,
      }}
      checked={value}
      onChange={onChange}
      onLabel={props.onLabel ?? 'ON'}
      offLabel={props.offLabel ?? 'OFF'}
      size={props.size ?? 'md'}
    />
  );
});
